import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { VivaBotFaceState } from '../../controls/viva-chat/viva-chat.component';

@Injectable({
  providedIn: 'root'
})
export class MockEventService {
  // HeyViva events
  private aiBotEmotionChangeSubject = new Subject<VivaBotFaceState>();
  public aiBotEmotionChange: Observable<VivaBotFaceState> = this.aiBotEmotionChangeSubject.asObservable();

  private aiBotAwakeStateSubject = new Subject<boolean>();
  public aiBotAwakeState: Observable<boolean> = this.aiBotAwakeStateSubject.asObservable();

  // Network events
  private networkStatusChangeSubject = new Subject<boolean>();
  public networkStatusChange: Observable<boolean> = this.networkStatusChangeSubject.asObservable();

  // Notification events
  private notificationCountSubject = new Subject<number>();
  public notificationCount: Observable<number> = this.notificationCountSubject.asObservable();

  // Gamification events
  private badgeEarnedSubject = new Subject<any>();
  public badgeEarned: Observable<any> = this.badgeEarnedSubject.asObservable();

  private gameAvailableSubject = new Subject<boolean>();
  public gameAvailable: Observable<boolean> = this.gameAvailableSubject.asObservable();

  // Loading events
  private loadingEventSubject = new Subject<number>();
  public loadingEvent: Observable<number> = this.loadingEventSubject.asObservable();

  // Emit methods
  emitAiBotEmotionChange(face: VivaBotFaceState): void {
    this.aiBotEmotionChangeSubject.next(face);
  }

  emitAiBotAwakeState(isAwake: boolean): void {
    this.aiBotAwakeStateSubject.next(isAwake);
  }

  emitNetworkStatusChange(isOnline: boolean): void {
    this.networkStatusChangeSubject.next(isOnline);
  }

  emitNotificationCount(count: number): void {
    this.notificationCountSubject.next(count);
  }

  emitBadgeEarned(badge: any): void {
    this.badgeEarnedSubject.next(badge);
  }

  emitGameAvailable(available: boolean): void {
    this.gameAvailableSubject.next(available);
  }

  emitLoadingEvent(loading: number): void {
    this.loadingEventSubject.next(loading);
  }
}

